// renamed to metrofetch - getAuthLayer method requires pure native fetch
import { fetch } from '@utils/utils';
import { get } from 'lodash';

export const getUserProfile = ({ addError }) => async (id: string): Promise<any> => {
  try {
    const response: any = await fetch(
      `/metropolis/api/common/sps/user-profile?filter[0].field=employee.id&filter[0].operation=EQ&filter[0].value=${id}`,
      {
        method: 'GET',
        headers: new Headers({ 'Content-Type': 'application/json' })
      }
    );

    const json = await response.json();

    const count = get(json, 'count', 0);
    const items = get(json, 'items', []);

    if (count) {
      return items[0];
    } else {
      return {};
    }
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const putUserProfile = ({ addError, addSuccess }) => async (formData): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/common/sps/user-profile/${get(formData, 'id')}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(formData)
    });

    const result = await response.json();
    addSuccess();
    return result;
  } catch (err) {
    addError(err.message);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/maps/_mapsActions.ts